import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  setPrimaryInfo,
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import ShareFeedbackPage from '../components/ShareFeedbackPage/ShareFeedbackPage'

const mapStateToProps = reduxState => {
  const { auth, profile, dashboard } = reduxState

  const { malls } = dashboard

  const { accessToken } = auth

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    malls,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPrimaryInfo,
      displayProfileModal,
      setProfileModalPage,
      waitRenderServer,
      renderServer,
    },
    dispatch,
  )

const ConnectedShareFeedbackPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShareFeedbackPage)

export default ConnectedShareFeedbackPage
